import React from 'react';
import { LayoutDashboardIcon, SearchIcon, MapPinIcon, FileTextIcon, MapIcon, BarChart3Icon, BellIcon, UserIcon, LogOutIcon } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
interface SidebarProps {
  currentPage: string;
  navigateTo: (page: string) => void;
}
export function Sidebar({
  currentPage,
  navigateTo
}: SidebarProps) {
  const {
    t
  } = useLanguage();
  const navItems = [{
    id: 'dashboard',
    icon: LayoutDashboardIcon,
    label: t('navDashboard')
  }, {
    id: 'myPlots',
    icon: MapPinIcon,
    label: t('navMyPlots')
  }, {
    id: 'map',
    icon: MapIcon,
    label: t('navMap')
  }, {
    id: 'reports',
    icon: BarChart3Icon,
    label: t('navReports')
  }, {
    id: 'notifications',
    icon: BellIcon,
    label: t('navNotifications')
  }];
  return <aside className="hidden md:flex flex-col w-64 bg-[#004D3A] text-white h-screen fixed left-0 top-0 z-20 shadow-xl" data-id="element-52">
      <div className="p-6 flex items-center space-x-3 border-b border-[#006A4E]" data-id="element-53">
        <div className="w-8 h-8 bg-[#C9A84C] rounded-full flex items-center justify-center" data-id="element-54">
          <MapPinIcon className="w-5 h-5 text-[#004D3A]" data-id="element-55" />
        </div>
        <h1 className="text-lg font-bold leading-tight" data-id="element-56">
          {t('appTitleShort')}
        </h1>
      </div>

      <nav className="flex-1 py-6 px-3 space-y-1 overflow-y-auto" data-id="element-57">
        {navItems.map(item => {
        const Icon = item.icon;
        const isActive = currentPage === item.id || currentPage.startsWith(item.id) && item.id !== 'dashboard';
        return <button key={item.id} onClick={() => navigateTo(item.id)} className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg transition-colors ${isActive ? 'bg-[#006A4E] text-[#C9A84C] font-medium' : 'text-gray-300 hover:bg-[#006A4E]/50 hover:text-white'}`} data-id="element-58">
              <Icon className="w-5 h-5" data-id="element-59" />
              <span data-id="element-60">{item.label}</span>
            </button>;
      })}
      </nav>

      <div className="p-4 border-t border-[#006A4E]" data-id="element-61">
        <button onClick={() => navigateTo('home')} className="w-full flex items-center space-x-3 px-4 py-3 rounded-lg text-gray-300 hover:bg-[#006A4E]/50 hover:text-white transition-colors" data-id="element-62">
          <LogOutIcon className="w-5 h-5" data-id="element-63" />
          <span data-id="element-64">{t('logout')}</span>
        </button>
      </div>
    </aside>;
}